export default __webpack_public_path__ + "static/media/7minfitness_12@3x.0c3608a8.jpg";